import Base from '#BASE/store/userInfo/userInfo.store';
import { getterTypes, mutationTypes, actionTypes } from 'BASE/store/types';
import { storage } from 'BASE/common/util/util.storage';
import constant from 'BASE/common/lotteryConstant';
export const dailyPayType = constant.DailyPayType;
export const ContractType = constant.ContractType;
export const ProportionalDividendType = constant.ProportionalDividendType;

export default class extends Base {
    constructor() {
        super();
        this.state.privileges.contractPermission = [];
        this.state.privileges.ProportionalDividendPermissions = [];
        this.state.privileges.haveProportionalDividend = undefined;
        this.state.privileges.proportionalDividendMARKSIXCreationAllowed = undefined;
        this.state.privileges.proportionalDividendLotteryCreationAllowed = undefined;
        this.state.privileges.sportDailyPayCreationAllowed = undefined;
        this.state.privileges.externalGameDailyPayCreationAllowed = undefined;
        this.state.privileges.sportContractCreationAllowed = undefined;
        this.state.privileges.externalGameContractCreationAllowed = undefined;
        // 待遇管理頁面開關
        this.state.privileges.bonusManagementAllowed = undefined;
        // 我的待遇頁面開關
        this.state.privileges.haveMyDailyPayAndContract = undefined;
        this.actions[actionTypes.USER_INFO_PRIVILEGES_BONUS] = async (context, payload) => {
            context.commit(mutationTypes.USER_INFO_PRIVILEGES_BONUS, {
                contractCreationAllowed: undefined,
                sportContractCreationAllowed: undefined,
                externalGameContractCreationAllowed: undefined,
                dailyPayCreationAllowed: undefined,
                sportDailyPayCreationAllowed: undefined,
                externalGameDailyPayCreationAllowed: undefined,
                haveContract: undefined,
                haveExternalGameContract: undefined,
                haveSportContract: undefined,
                haveDailyPay: undefined,
                haveExternalGameDailyPay: undefined,
                haveSportGameDailyPay: undefined,
                dailyPayPermission: [],
                contractPermission: [],
                ProportionalDividendPermissions: [],
                haveProportionalDividend: undefined,
                proportionalDividendMARKSIXCreationAllowed: undefined,
                proportionalDividendLotteryCreationAllowed: undefined,
                haveBonusWallet: undefined,
                bonusManagementAllowed: undefined,
                haveMyDailyPayAndContract: undefined,
            });
            if (storage.local.get(storage.keys.ACCESS_TOKEN)) {
                try {
                    let _result = await $.post('/api/BonusPrivileges/Get');
                    let dailyPayCreationAllowed =  _result.dailyPayPermission.find(permission => permission === dailyPayType.BET_PAY || permission === dailyPayType.MARK_SIX) ? true : false;
                    let sportDailyPayCreationAllowed = _result.dailyPayPermission.find(permission => permission === dailyPayType.SPORT) ? true : false;
                    let externalGameDailyPayCreationAllowed = _result.dailyPayPermission.find(permission => permission === dailyPayType.VIDEO_SLOT) ? true : false;
                    let contractCreationAllowed = _result.contractPermission.find(permission => permission === ContractType.LOTTERY) === 0 ? true : false;
                    let sportContractCreationAllowed = _result.contractPermission.find(permission => permission === ContractType.SPORT) ? true : false;
                    let externalGameContractCreationAllowed = _result.contractPermission.find(permission => permission === ContractType.VIDEO_SLOT) ? true : false;
                    let proportionalDividendMARKSIXCreationAllowed = _result.ProportionalDividendPermissions.find(id => id === ProportionalDividendType.LOTTERY) === 0 ? true : false;
                    let proportionalDividendLotteryCreationAllowed = _result.ProportionalDividendPermissions.find(id => id === ProportionalDividendType.LOTTERY_GAME) ? true : false;
                    let bonusManagementAllowed = _result.dailyPayPermission.length > 0 || _result.contractPermission.length > 0 ? true : false;
                    let haveMyDailyPayAndContract = (_result.haveDailyPay || _result.haveExternalGameDailyPay || _result.haveSportGameDailyPay ||
                        _result.haveContract || _result.haveExternalGameContract || _result.haveSportContract) ? true : false;
                    context.commit(mutationTypes.USER_INFO_PRIVILEGES_BONUS, {
                        contractCreationAllowed: contractCreationAllowed,
                        sportContractCreationAllowed: sportContractCreationAllowed,
                        externalGameContractCreationAllowed: externalGameContractCreationAllowed,
                        dailyPayCreationAllowed: dailyPayCreationAllowed,
                        haveContract: _result.haveContract,
                        haveExternalGameContract: _result.haveExternalGameContract,
                        haveSportContract: _result.haveSportContract,
                        haveDailyPay: _result.haveDailyPay,
                        haveExternalGameDailyPay: _result.haveExternalGameDailyPay,
                        haveSportGameDailyPay: _result.haveSportGameDailyPay,
                        dailyPayPermission: _result.dailyPayPermission,
                        sportDailyPayCreationAllowed: sportDailyPayCreationAllowed,
                        externalGameDailyPayCreationAllowed: externalGameDailyPayCreationAllowed,
                        contractPermission: _result.contractPermission,
                        ProportionalDividendPermissions: _result.ProportionalDividendPermissions,
                        haveProportionalDividend: _result.haveProportionalDividend,
                        proportionalDividendMARKSIXCreationAllowed: proportionalDividendMARKSIXCreationAllowed,
                        proportionalDividendLotteryCreationAllowed: proportionalDividendLotteryCreationAllowed,
                        haveBonusWallet: _result.haveBonusWallet,
                        bonusManagementAllowed: bonusManagementAllowed,
                        haveMyDailyPayAndContract: haveMyDailyPayAndContract,
                    });
                }
                catch (err) {
                    console.error(err);
                }
            }
        };
        this.mutations[mutationTypes.USER_INFO_PRIVILEGES_BONUS] = (state, payload) => {
            state.privileges.contractCreationAllowed = payload.contractCreationAllowed;
            state.privileges.sportContractCreationAllowed = payload.sportContractCreationAllowed;
            state.privileges.externalGameContractCreationAllowed = payload.externalGameContractCreationAllowed;
            state.privileges.dailyPayCreationAllowed = payload.dailyPayCreationAllowed;
            state.privileges.sportDailyPayCreationAllowed = payload.sportDailyPayCreationAllowed;
            state.privileges.externalGameDailyPayCreationAllowed = payload.externalGameDailyPayCreationAllowed;
            state.privileges.haveContract = payload.haveContract;
            state.privileges.haveExternalGameContract = payload.haveExternalGameContract;
            state.privileges.haveSportContract = payload.haveSportContract;
            state.privileges.haveDailyPay = payload.haveDailyPay;
            state.privileges.haveExternalGameDailyPay = payload.haveExternalGameDailyPay;
            state.privileges.haveSportGameDailyPay = payload.haveSportGameDailyPay;
            state.privileges.dailyPayPermission = payload.dailyPayPermission;
            state.privileges.contractPermission = payload.contractPermission;
            state.privileges.ProportionalDividendPermissions = payload.ProportionalDividendPermissions;
            state.privileges.haveProportionalDividend = payload.haveProportionalDividend,
            state.privileges.proportionalDividendMARKSIXCreationAllowed = payload.proportionalDividendMARKSIXCreationAllowed;
            state.privileges.proportionalDividendLotteryCreationAllowed = payload.proportionalDividendLotteryCreationAllowed;
            state.privileges.haveBonusWallet = payload.haveBonusWallet;
            state.privileges.bonusManagementAllowed = payload.bonusManagementAllowed;
            state.privileges.haveMyDailyPayAndContract = payload.haveMyDailyPayAndContract;
        };
    }
}